// Lanarkshire Cleaning Company — uploaded brand assets
const BASE =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_8ba87282-872c-43b4-9a12-ddc9b7410bcf/artifacts";
const MEDIA =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_carpet-fresh-glasgow/artifacts";

export const ASSETS = {
  logo: "/brand-assets/logo.png",
  van: "/brand-assets/van.webp",
  // Before & After — entrance hallway carpet
  hallwayBefore: "/brand-assets/hallwayBefore.png",
  hallwayAfter: "/brand-assets/hallwayAfter.png",
  // Recent cleaning results
  sofa: "/brand-assets/sofa.png",
  livingRoom: "/brand-assets/livingRoom.png",
  livingRoomAfter: "/brand-assets/livingRoomAfter.png",
};

export const CONTACT = {
  name: "Lanarkshire Cleaning Company",
  location: "Airdrie, United Kingdom",
  phone: "07395 908964",
  phoneHref: "tel:+447395908964",
  whatsapp: "+44 7395 908964",
  whatsappHref: "https://wa.me/447395908964",
  email: "lanarkshirecleaning@outlook.com",
  emailHref: "mailto:lanarkshirecleaning@outlook.com",
  facebook: "https://www.facebook.com/lanarkshirecarpetcleaning/",
  hours: "Always open",
};

export const AREAS = [
  "Glasgow",
  "South Lanarkshire",
  "North Lanarkshire",
  "East Kilbride",
  "West Lothian",
  "Edinburgh",
  "Cumbernauld",
  "Falkirk",
  "Kilmarnock",
  "Ayrshire",
];
